"use client";

import type { ReactNode } from "react";
import { useTranslations } from "next-intl";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export function AiAgentDetailTabs({
  children,
  historyTargetId,
}: {
  children: ReactNode;
  historyTargetId: string;
}) {
  const t = useTranslations("site.ai.detailTabs");

  return (
    <Tabs defaultValue="intro" className="jzt-ai-agent-tabs">
      <TabsList className="jzt-ai-agent-tab-list">
        <TabsTrigger value="intro">{t("intro")}</TabsTrigger>
        <TabsTrigger value="history">{t("history")}</TabsTrigger>
      </TabsList>
      <TabsContent value="intro" keepMounted className="jzt-ai-agent-tab-content">
        {children}
      </TabsContent>
      <TabsContent value="history" keepMounted className="jzt-ai-agent-tab-content jzt-ai-agent-history-content">
        <div id={historyTargetId} className="min-h-0 flex-1" />
      </TabsContent>
    </Tabs>
  );
}
